import { IconProps } from './IconProps';

export const LightingPresetIcon = ({ className, width = 31, height = 32 }: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 31 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#2396FD" fillRule="nonzero">
      <path d="M25.2 14.467v-2.334H10.983V9.3h-2.48v2.833H.4v2.334h8.103V17.3h2.48v-2.833zM25.2 6.067V3.733h-6.217V.9h-2.48v2.833H.4v2.334h16.103V8.9h2.48V6.067zM25.2 22.867v-2.334h-9.417V17.7h-2.48v2.833H.4v2.334h12.903V25.7h2.48v-2.833z" />
    </g>
  </svg>
);
